import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { resetPassword, setTechnicianPassword } from '../features/authSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import eyeIcon from '../assets/images/eye.svg';
import CKALogo from '../assets/images/CKA Birla_Logo.svg';
import BirlanuLogo from '../assets/images/birlanu_water_tank_logo.svg';
import '../styles/forgotpassword.css';
import eyeShowIcon from '../assets/images/eye_show.svg';

const SetPassword = ({ email }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const userId = params.get('userId');
  const emailFromQuery = params.get('email');

  const validatePassword = (pwd) => {
    return /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(pwd);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePassword(password)) {
      setError('Password must be at least 8 characters with 1 uppercase, 1 number, and 1 special character');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    let result;
    if (emailFromQuery) {
      // Technician password set flow
      result = await dispatch(setTechnicianPassword({ email: emailFromQuery, password }));
      if (setTechnicianPassword.fulfilled.match(result)) {
        toast.success('Password set successfully! Please login.');
        setTimeout(() => {
          navigate('/success');
        }, 1500);
      } else {
        toast.error(result.payload || 'Password set failed');
      }
    } else {
      // Default reset password flow
      const payload = userId ? { userId, password } : { email, password };
      result = await dispatch(resetPassword(payload));
      if (resetPassword.fulfilled.match(result)) {
        toast.success('Password set successfully! Please login.');
        setTimeout(() => {
          navigate('/success');
        }, 1500);
      } else {
        toast.error(result.payload || 'Password set failed');
      }
    }
  };

  return (
    <div className="login-wrapper">
      <div>
        <div className="login-logo">
          <img src={BirlanuLogo} alt="Birlanu Water Tank Logo" />
        </div>
        <div className="login-form">
          <h1>Create New Password</h1>
          <h3> Please enter and confirm your new password.
            You will need to login after you set your password.</h3>
          <form onSubmit={handleSubmit} className="form-info">
            <label htmlFor="password" className="form-label">Password</label>
            <div className="password-section">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                className="form-input mb-0"
                style={{
                  marginBottom: error ? '4px' : '',
                  borderColor: error ? '#D7184D' : '',
                }}
                placeholder="Enter your password"
                onChange={e => {
                  const value = e.target.value;
                  if (!value.includes(' ')) {
                    setPassword(value);
                  }
                }}
                onKeyDown={e => {
                  if (e.key === ' ') {
                    e.preventDefault();
                  }
                }}
                value={password}
              />
              <span
                className="ico-eye"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label="Toggle password visibility"
                role="button"
                tabIndex={0}
              >
                <img
                  src={showPassword ? eyeShowIcon : eyeIcon}
                  alt={showPassword ? 'Show password' : 'Hide password'}
                  style={{
                    width: 24,
                    height: 24,
                    opacity: 1,
                  }}
                />
              </span>
            </div>
            <div className="password-info-text">
              At least 8 characters with 1 uppercase, 1 number, and 1 special character
            </div>
            {error && <div className="login-input-error">{error}</div>}
            <label htmlFor="password" className="form-label"> Confirm Password</label>
            <div className="password-section">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                id="confirmPassword"
                className="form-input mb-0"
                style={{
                  marginBottom: error ? '4px' : '',
                  borderColor: error ? '#D7184D' : '',
                }}
                placeholder="Enter your password"
                onChange={e => {
                  const value = e.target.value;
                  if (!value.includes(' ')) {
                    setConfirmPassword(value);
                  }
                }}
                onKeyDown={e => {
                  if (e.key === ' ') {
                    e.preventDefault();
                  }
                }}
                value={confirmPassword}
              />
              <span
                className="ico-eye"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                aria-label="Toggle password visibility"
                role="button"
                tabIndex={0}
              >
                <img
                  src={showConfirmPassword ? eyeShowIcon : eyeIcon}
                  alt={showConfirmPassword ? 'Show password' : 'Hide password'}
                  style={{
                    width: 24,
                    height: 24,
                    opacity: 1,
                  }}
                />
              </span>
            </div>

            <button type="submit" className="login-btn">
              Continue
            </button>
          </form>

        </div>
      </div>
      <div className="footer-section">
        <img src={CKALogo} alt="CKA Birla Logo" />
        <div className="footer-links">
          <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link>
          <span>&nbsp;|&nbsp;</span>
          <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
        </div>
      </div>

    </div>

  );
};

export default SetPassword;
